import CompanyService from '../../service/company';
import ReduxVip from "./vip";

const Action = {
    GET_COMPANY: "GET_COMPANY",
    SET_COMPANY: "SET_COMPANY",
    GET_VIPS_IN_COMPANY: "GET_VIPS_IN_COMPANY",
    GET_COMPANIES: "GET_COMPANIES",
    NEW_COMPANY: "NEW_COMPANY",
    UPDATE_COMPANY: "UPDATE_COMPANY",
};

const ActionCreator = {
    addCompany(company, email) {
        return async (dispatch) => {
            try {
                if(company.email) delete company.email;
                const newCompany = await CompanyService.add(company, email);
                dispatch({type: Action.NEW_COMPANY, company: newCompany});
                return newCompany;
            } catch (error) {
                throw dispatch({error});
            }
        };
    },
    getVips(companyId) {
        return async (dispatch, getState) => {
            try {
                const vips = await dispatch(ReduxVip.ActionCreator.getVips());
                const vipsInCompany = vips.filter((vip) => {
                    if (!vip.group) return false;
                    if (!vip.group.company) return false;
                    return vip.group.company.id === companyId;
                });
                dispatch({type: Action.GET_VIPS_IN_COMPANY, vips: vipsInCompany});
                dispatch({type: ReduxVip.Action.GET_COMPANY_VIPS, companyVips: vipsInCompany});
                return vipsInCompany;
            } catch (error) {
                throw dispatch({error});
            }
        };
    },
    setCompany(company) {
        return {type: Action.SET_COMPANY, company};
    },
    getCompany(companyId) {
        return async (dispatch) => {
            try {
                const company = await CompanyService.findById(companyId);
                dispatch({type: Action.GET_COMPANY, company});
                return company;
            } catch (error) {
                throw dispatch({error});
            }
        };
    },
    getCompanies() {
        return async (dispatch) => {
            try {
                const companies = await CompanyService.list();
                dispatch({type: Action.GET_COMPANIES, companies});
                return companies;
            } catch (error) {
                throw dispatch({error});
            }
        };
    },
    updateCompany(company) {
        return async (dispatch) => {
            try {
                const newCompany = await CompanyService.update(company);
                dispatch({type: Action.UPDATE_COMPANY, company: newCompany});
                return newCompany;
            } catch (error) {
                throw dispatch({error});
            }
        };
    },
    deleteCompany(companyId) {
        return async (dispatch) => {
            try {
                return await CompanyService.deleteById(companyId);
            } catch (error) {
                throw dispatch({error});
            }
        };
    },
    joinVips({companyId, vipIds}) {
        return async (dispatch) => {
            try {
                return await CompanyService.joinVips({companyId, vipIds});
            } catch (error) {
                throw dispatch({error});
            }
        };
    },
    joinNewVips({companyId, vips}) {
        console.log('vips=', vips);
        return async (dispatch) => {
            try {
                return await CompanyService.joinNewVips({companyId, vips});
            } catch (error) {
                throw dispatch({error});
            }
        };
    },
};

const initialState = {
    companies: [],
    company: {},
    vips: []
};

const Reducer = function (state = initialState, action) {
    switch (action.type) {
        case Action.GET_COMPANY:
        case Action.NEW_COMPANY:
        case Action.SET_COMPANY:
        case Action.UPDATE_COMPANY:
            return {
                ...state,
                company: action.company
            };
        case Action.GET_COMPANIES:
            return {
                ...state,
                companies: action.companies
            };
        case Action.GET_VIPS_IN_COMPANY:
            return {
                ...state,
                vips: action.vips
            };
        default: {
            return state;
        }
    }
};

export default {Action, ActionCreator, Reducer};



// WEBPACK FOOTER //
// ./src/store/actionreducers/company.js